import { _ } from "../../../../core/polyglot/polyglot.js";
import AccountingDocumentWidget from "../../../shared/documentInfrastructure/AccountingDocumentWidget.js";
import TitleWidget from "../../../../core/chrome/TitleWidget2.js";

/**
 * Render the forecast template archive's title.
 */
export default class ForecastTemplateArchiveTitleWidget extends AccountingDocumentWidget {
	setup(...rest) {
		super.setup(...rest);

		this._title = new TitleWidget({
			title: this._renderTitleOn.bind(this),
		});
	}

	renderContentOn(html) {
		if (!this._title) return;
		html.render(this._title);
	}

	_renderTitleOn(html) {
		html.render(_("Forecast Templates"));
	}
}
